import { combineReducers } from 'redux';
import { task } from '@breezeway/brzw-react-core';

export default combineReducers({
  entities: task.reducers.currentTaskEntities,
  flyoutTask: task.reducers.flyoutTask,
  propertyElements: task.reducers.propertyElements,
  reports: task.reducers.currentTaskReports,
  scheduledWorkflow: task.reducers.scheduledWorkflow,
  task: task.reducers.currentTask,
  taskHistory: task.reducers.taskHistory,
  taskProperty: task.reducers.currentTaskProperty,
  taskSeries: task.reducers.taskSeries,
  taskSupplies: task.reducers.taskSupplies,
  taskTemplate: task.reducers.currentTaskTemplate,
  taskTemplateEntities: task.reducers.currentTaskTemplateEntities,
  taskTiming: task.reducers.currentTaskTiming,
  taskTimingDetails: task.reducers.taskTimingDetails,
});
